import {creditPacksService} from "@/_services";
import router from "@/router";

export default {
  getAll({dispatch, commit}, {page, sort, search}) {
    return creditPacksService.getAll(page, sort, search)
      .then(
        creditPacks => {
          /*let freePlanCredits = creditPacks.data.filter(creditpack => !creditpack.is_for_paid_plan)
          let paidPlanCredits = creditPacks.data.filter(creditpack => creditpack.is_for_paid_plan)
          commit("setFreePlanCreditPacks", freePlanCredits)
          commit("setPaidPlanCreditPacks", paidPlanCredits)*/
          return Promise.resolve(creditPacks);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  buyCreditPack({dispatch, commit}, {creditPackId, paymentMethod, aclChangeRole}) {
    return creditPacksService.buyCreditPack(creditPackId, paymentMethod)
      .then(
        result => {
          return dispatch("account/me", {aclChangeRole}, {root: true}).then(
            () => {
              return Promise.resolve(result);
            },
            () => {
              return Promise.resolve(result);
            }
          )
        },
        error => {
          return Promise.reject(error ? error : "Hubo un problema al realizar el pago, es probable que no tengas configurado un metodo de pago");
        }
      )
  },
  buySignatures({dispatch, commit}, {amount, paymentMethod, cardId, aclChangeRole}) {
    return creditPacksService.buySignatures(amount, paymentMethod, cardId)
      .then(
        result => {
          return dispatch("account/me", {aclChangeRole}, {root: true}).then(
            () => {
              return Promise.resolve(result);
            },
            () => {
              return Promise.resolve(result);
            }
          )
        },
        error => {
          return Promise.reject(error ? error : "Hubo un problema al realizar el pago, es probable que no tengas configurado un metodo de pago");
        }
      )
  }
}
